var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import styled from 'styled-components';
import { Text } from "../../Text";
import { measureText } from "../../helpers/measureText";
export var TooltipText = styled(Text)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    word-break: keep-all; /* for support IE */\n    word-break: break-word; /* for support Chrome */\n"], ["\n    word-break: keep-all; /* for support IE */\n    word-break: break-word; /* for support Chrome */\n"])));
export var onMouseEnterHandlerDecorator = function (tooltipHandler, ref) {
    return function () {
        var _a = measureText(ref), originalWidth = _a.originalWidth, fullWidth = _a.fullWidth;
        if (fullWidth > originalWidth) {
            tooltipHandler();
        }
    };
};
var templateObject_1;
//# sourceMappingURL=helpers.js.map